import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import Container from '@components/Container';
import Text, { TEXT_SIZE, TEXT_COLOR } from '@components/Text';

import { StyledPersonIcon } from '@containers/App/containers/Messaging/components/MessagesList/styles';
import {
  Wrapper,
  StyledAvatar,
  UserInfo,
  StyledRemoveIcon,
} from './styles';

class ConversationHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      currentConversation,
      isNewConversationStarted,
      selectedUser,
      t,
    } = this.props;
    if (!isNewConversationStarted && _.isEmpty(currentConversation)) return null;

    if (!selectedUser && (!currentConversation
      || !currentConversation.Thread
      || !currentConversation.Thread.Posts
      || !currentConversation.Thread.Posts.length)
    ) return null;
    const userData = isNewConversationStarted
      ? selectedUser
      : currentConversation.Users.find((user) => !user.self);

    return (
      <Wrapper>
        <Container>
          {userData?.avatar ? <StyledAvatar src={userData.avatar} /> : <StyledPersonIcon />}
          <UserInfo>
            <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.NORMAL}>
              {userData?.fullName}
            </Text>
            {userData?.isMentor && (
              <Text size={TEXT_SIZE.T4} textColor={TEXT_COLOR.DISABLED}>
                {t('Common.Roles.mentor')}
              </Text>
            )}
          </UserInfo>
        </Container>
        {isNewConversationStarted && (
          <StyledRemoveIcon onClick={this.props.removeConversationPartner} />
        )}
      </Wrapper>
    );
  }
}

ConversationHeader.propTypes = {
  currentConversation: PropTypes.object,
  isNewConversationStarted: PropTypes.bool,
  selectedUser: PropTypes.object,
  removeConversationPartner: PropTypes.func,
};

export default compose(
  withTranslation(),
)(ConversationHeader);
